"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { MapPin, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StAlbansCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="stalbanscta" data-nav="light" ref={ref} className="relative bg-background text-foreground py-20 md:py-28 lg:py-32 overflow-hidden border-b border-border/40">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div style={{
        opacity: isVisible ? 1 : 0
      }} className={`transition-all duration-700 ease-out transform ${isVisible ? "translate-y-0" : "translate-y-6"} flex flex-col items-center text-center`}>
          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground max-w-2xl">
            Visiting Batchwood
          </h2>

          {/* Address Card */}
          <div className="mt-8 sm:mt-10 w-full max-w-lg border border-border/80 bg-card text-card-foreground shadow-sm rounded-lg p-8 sm:p-10 flex flex-col items-center text-center">
            <div className="size-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-5 shrink-0">
              <MapPin className="size-6 text-primary" aria-hidden="true" />
            </div>

            <address className="not-italic space-y-1.5 text-base sm:text-lg text-foreground">
              <span className="block font-semibold text-foreground">
                Batchwood Golf and Sports Centre
              </span>
              <span className="block text-muted-foreground">
                Batchwood Drive
              </span>
              <span className="block text-muted-foreground">
                St Albans
              </span>
              <span className="block font-medium tracking-wide text-foreground">
                AL3 5XA
              </span>
            </address>
          </div>

          {/* Closing Action Button */}
          <div className="mt-8 sm:mt-10">
            <Button asChild size="lg" className="rounded-lg px-8 py-6 text-base font-medium shadow-sm hover:shadow transition-all">
              <Link to="https://physiogenics.uk3.cliniko.com/bookings?business_id=1933385715966552600" newTab className="inline-flex items-center gap-2">
                <SafeHydrate><Calendar className="size-4" aria-hidden="true" /></SafeHydrate>
                <span>Book an Appointment</span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}